export enum Type {
  NOTIFICATION_ALERT_REQUEST = 'app/notification-alert/NOTIFICATION_ALERT_REQUEST',
  NOTIFICATION_ALERT_FAILURE = 'app/notification-alert/NOTIFICATION_ALERT_FAILURE',
  NOTIFICATION_ALERT_SUCCESS = 'app/notification-alert/NOTIFICATION_ALERT_SUCCESS',

  NOTIFICATION_ALERT_UPDATE_REQUEST = 'app/notification-alert/NOTIFICATION_ALERT_UPDATE_REQUEST',
  NOTIFICATION_ALERT_UPDATE_SUCCESS = 'app/notification-alert/NOTIFICATION_ALERT_UPDATE_SUCCESS',
  NOTIFICATION_ALERT_UPDATE_FAILURE = 'app/notification-alert/NOTIFICATION_ALERT_UPDATE_FAILURE',
}
